<template>
  <div>
    <div class="form-date-time-container">
      <div class="input-group time input-group-date">
        <span class="input-group-addon"><i class="far fa-clock"></i></span>
        <input
          ref="inputField"
          type="time"
          :class="[`form-control`, { 'is-invalid': hasError() }]"
          :value="timeValue"
          @input="updateTime" />
      </div>
      <div class="input-group date input-group-date">
        <span class="input-group-addon" @click.stop="$refs.datePickerInput.click()"><i class="far fa-calendar"></i></span>
        <v-date-picker
        ref="datePicker"
        mode='single'
        :value="selectedValue"
        @input="updateDate"
        :popover="configPopover"
        :input-debounce="250"
        :update-on-input="false"
        locale="en-AU">
          <input
              ref="datePickerInput"
              slot-scope="{ inputProps, inputEvents }"
              :placeholder="placeholder"
              :class="[`form-control form-control-date`, { 'is-invalid': hasError() }]"
              v-bind="inputProps"
              v-on="inputEvents"
              v-on:keyup.enter="$refs.datePicker.hidePopover()" />
        </v-date-picker>
      </div>
    </div>
    
    <div class="form-invalid-feedback" v-if="hasError()" style="clear: both;">
      {{getError()}}
    </div>
    <span v-if="!hasError() && note" class="form-field-note">{{note}}</span>
  </div>
</template>

<style>
.form-date-time-container {
  display: flex;
  align-items: stretch;
}
.form-date-time-container > div {
  flex: 40%;
  margin-right: 10px;
}
.form-control-date[readonly] {
  background-color: #ffffff;
}
.input-group-date {
  flex-wrap: nowrap;
}
.input-group-date .input-group-addon {
  border-right: none;
}
</style>

<script>
import formField from '@/mixins/formField'
import moment from 'moment'

export default {
  name: "FormDateTime",
  mixins: [formField],
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: String,
    field: String,
    note: String,
  },
  components: {
    
  },
  data() {
    var curValue = null
    if(this.$props.value) {
      let valueDate = moment(this.$props.value)
      if(valueDate.isValid())
        curValue = valueDate.toDate()
    }
    // Default to now if not set
    if(!curValue)
      curValue = moment().local().toDate()

    return {
      selectedValue: curValue,
      configPopover: {
        keepVisibleOnInput: false,
        positionFixed: true,
        visibility: 'click',
        transition: 'none'
      },
    }
  },
  computed: {
    timeValue() {
      if(this.selectedValue) {
        var selDate = moment(this.selectedValue)
        if(selDate.isValid())
          return selDate.local().format('HH:mm')
      }
      return '00:00'
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      // Default to empty string if null given
      if(newVal == null) {
        this.$nextTick(() => {
          this.$emit('input', '')
        })
      } else {
        var dateVal = moment(newVal)
        if(dateVal.isValid())
          this.$data.selectedValue = dateVal.toDate()
      }
    },
    selectedValue: function(newVal, oldVal) {
      try {
        if(newVal != null)
          this.$emit('input', newVal.toISOString())
      } catch {}
    }
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
    updateValue(evt) {
      this.$emit('input', evt.toISOString())
    },
    updateDate(evt) {
      this.$data.selectedValue = moment(moment(evt).local().format('YYYY-MM-DD') + 'T' + moment(this.$data.selectedValue).local().format('HH:mm:ssZ')).toDate()
    },
    updateTime(evt) {
      var timeEntry = moment(evt.target.value, 'HH:mm:ss')
      if(!timeEntry.isValid())
        return

      this.$data.selectedValue = moment(moment(this.$data.selectedValue).local().format('YYYY-MM-DD') + 'T' + timeEntry.local().format('HH:mm:ssZ')).toDate()
    }
  }
};
</script>